import PageShell from "@/components/site/PageShell";
import PageHero from "@/components/site/PageHero";
import { usePageContent } from "@/i18n/pageContent";

const IMAGES = [
  "/board-consiglio-1.jpg",
  "/board-consiglio-2.jpg",
  "/board-consiglio-3.jpg",
];

export default function InternationalBoard() {
  const c = usePageContent("internationalBoard");
  return (
    <PageShell>
      <PageHero
        eyebrow={c.eyebrow}
        title={<>{c.titleA} <span className="italic">{c.titleB}</span>.</>}
        subtitle={c.subtitle}
      />

      {(c.blocks || []).map((b, i) => (
        <section
          key={b.eyebrow}
          className={i % 2 === 0 ? "bg-white py-20 md:py-28" : "bg-[#fafaf7] py-20 md:py-28"}
        >
          <div className="max-w-7xl mx-auto px-6 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
            <div className={`lg:col-span-6 reveal ${i % 2 === 1 ? "lg:order-2" : ""}`}>
              <div className="zoom-wrap aspect-[4/3] w-full">
                <img src={IMAGES[i] || IMAGES[0]} alt={b.eyebrow} loading="lazy" className="w-full h-full object-cover" />
              </div>
            </div>
            <div className="lg:col-span-6 reveal delay-1">
              <span className="eyebrow">{b.eyebrow}</span>
              <h2 className="font-display text-3xl md:text-5xl text-[#1a365d] mt-5 leading-[1.08] tracking-tight">
                {b.titleA} <span className="italic">{b.titleB}</span>.
              </h2>
              <div className="mt-7 space-y-5 text-[#475569] leading-[1.85] text-base md:text-[17px]">
                {b.paragraphs.map((p, idx) => (
                  <p key={idx}>{p}</p>
                ))}
              </div>
            </div>
          </div>
        </section>
      ))}
    </PageShell>
  );
}
